import { useSelector } from "react-redux";
import { CEBagErrors } from "rtr-constants";

export default function AddToBagError() {
  const smBagError = useSelector(state => state.smBag?.smBagError);
  const ceBagErrorMsg = useSelector(state => state.ceBagErrorMessage);

  if (!smBagError && !ceBagErrorMsg) return null;

  const errorMessage =
    CEBagErrors?.[smBagError?.responseJSON?.errors?.[0]?.code] ||
    CEBagErrors?.[smBagError?.responseText] ||
    ceBagErrorMsg ||
    CEBagErrors.ATB_GENERIC_ERROR;

  return <div className="mt-6 p-3 bg-lightMutedRed">{errorMessage}</div>;
}
